/* eslint-disable quotes */
/*global data*/
import Swiper from "swiper";
import "ekko-lightbox/dist/ekko-lightbox.js";

function getMerkatariak() {
  $("#shops-list-wrapper").empty();
  $("#loader").toggleClass("d-none");

  $.ajax({
    type: "POST",
    url: data.ajax_url,
    data: {
      action: "get_filtered_shops",
      paged: paged,
      taxonomy: taxonomy,
      search: search,
    },
    success: function (result) {
      $("#loader").toggleClass("d-none");
      $("#shops-list-wrapper").html(result);
      window.scrollTo(0, 0);
    },
    error: function () {
      console.log("Error");
    },
  });
}

function checkFormValidity(element) {
  var decode_pattern = element.attr("pattern");
  var reg = RegExp("^" + decode_pattern + "$");

  if (
    (element.prop("required") && !element.val()) ||
    !reg.test(element.val())
  ) {
    element.addClass("is-invalid");
    element.removeClass("is-valid");
    return false;
  } else {
    element.removeClass("is-invalid");
    element.addClass("is-valid");
    return true;
  }
}

function checkTaxonomies() {
  $(".taxonomy-button").each(function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    }
  });
}

function getNews() {
  $.ajax({
    type: "POST",
    url: data.ajax_url,
    data: {
      action: "get_news",
      paged: paged,
    },
    success: function (result) {
      $("#news-list-wrapper").empty().html(result);
    },
    error: function () {
      console.log("Error");
    },
  });
}

function updateUrl() {
  let getParams = [];
  getParams["pag"] = paged;

  if (search) {
    getParams["search"] = search;
  }

  if (taxonomy) {
    getParams["cat"] = taxonomy;
  }

  const urlParts = Object.entries(getParams).map(([k, v]) => {
    return `${k}=${v}`;
  });

  history.pushState(undefined, undefined, "?" + urlParts.join("&"));
}

let paged = 1;
let taxonomy;
let search;

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // When JS is active, stop URL event propagation
    // event.stopPropagation();

    //PAGINATION SECTION
    $("body").on("click", ".page-link", function () {
      let isMerkatariSection = $("#pagination").hasClass(
        "merkatari-pagination"
      );
      paged = $(this).attr("value");

      if (isMerkatariSection) {
        getMerkatariak();
        updateUrl();
      } else {
        getNews();
      }
    });

    // TAXONOMIES FILTER
    $(".taxonomy-button").on("click", function () {
      // Clear search input value
      $("#search-input").val('');
      search = '';

      paged = 1;

      if (!$(this).hasClass("active")) {
        checkTaxonomies();

        $(this).addClass("active");
        taxonomy = $(this).attr("value");
      } else {
        checkTaxonomies();
        $(".all-items").addClass("active");
        taxonomy = null;
      }

      getMerkatariak();
      updateUrl();
    });

    // CHECK USER DATA
    let values = [];
    let formInputs = $("form#clientForm").find("input");
    formInputs.each(function () {
      $(this).on("blur", function () {
        let input = {
          name: $(this).attr("name"),
          value: checkFormValidity($(this)),
        };

        let exist = values.findIndex((el) => el.name === $(this).attr("name"));
        if (exist > -1) {
          values[exist].value = checkFormValidity($(this));
        } else if (input.name) {
          values.push(input);
        }

        if (values.length >= formInputs.length) {
          let allGood = values.every((val) => val.value === true);

          if (allGood) {
            $("#confirmBtn").prop("disabled", false);
          } else {
            $("#confirmBtn").prop("disabled", true);
          }
        }
      });
    });

    // SWIPER
    if ($("#swiper-images").length > 0) {
      new Swiper("#swiper-images", {
        slidesPerView: 1,
        slidesPerColumn: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        },
      });

      const swiper = document.querySelector("#swiper-images").swiper;
      $(".shop-swiper")
        .on("click", ".swiper-button-prev", function () {
          swiper.slidePrev();
        })
        .on("click", ".swiper-button-next", function () {
          swiper.slideNext();
        });
    }

    // SHOW MORE BUTTON
    /* $("body").on("click", ".show-more-button", function () {
      let excerpt = $(this).siblings(".excerpt-content");
      let more = $(this).siblings(".more-content");
      let linkText = $(this).text().toUpperCase();

      if (linkText === "SHOW MORE") {
        linkText = "Show less";
        more.removeClass("d-none", 400);
        excerpt.addClass("d-none", 400);
      } else {
        linkText = "Show more";
        more.addClass("d-none", 400);
        excerpt.removeClass("d-none", 400);
      }

      $(this).text(linkText);
    }); */

    // BOOSTRAP LIGHBOX
    $(document).on("click", '[data-toggle="lightbox"]', function (event) {
      event.preventDefault();

      $(this).ekkoLightbox({
        // alwaysShowClose: true,
        wrapping: true,
      });

      let section = this.getAttribute("data-section");
      $(".ekko-lightbox").addClass(section + "-section");
    });

    // SEARCH INPUT
    $("#search-button").on("click", function () {
      search = $("#search-input").val();
      paged = 1;
      getMerkatariak();
      updateUrl();
    });

    $("#search-input").on('keyup', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        $('#search-button').trigger('click');
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js